import React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import "../styles/blog-post.css"
import styles from "../styles/blog-post.module.css"
import logo from "../../content/assets/logo.svg"
const BlogPostTemplate = ({ data, pageContext, location }) => {
const post = data.markdownRemark
const siteTitle = data.site.siteMetadata.title
const { previous, next } = pageContext

  return (
    <Layout location={location} title={siteTitle}>
      <SEO
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
      />
      <article className={styles.post}>
        <header>
          <h1 className={styles.postTitle}>{post.frontmatter.title}</h1>
          <div className={styles.postMeta}>
            <div className={styles.postAuthor}>
              <Link to="" class={styles.postAuthorAvatar}>
                <img src={logo} alt="author-avatar" height="239" width="" />
              </Link>
              <Link to="" class={styles.postAuthorName}>
                anhat.dev
              </Link>
            </div>
  <time className={styles.postTime}>{post.frontmatter.date}</time>
          </div>
        </header>
        <figure className={styles.postThumbnail}>
          <img src={post.frontmatter.featuredImage} alt="thumbnail" />
        </figure>
        <section dangerouslySetInnerHTML={{ __html: post.html }} class="content"/>
        <footer></footer>
      </article>
      <div className={styles.postNavigation}>
        <nav>
          <ul
            style={{
              display: `flex`,
              flexWrap: `wrap`,
              justifyContent: `space-between`,
              listStyle: `none`,
              padding: 0,
            }}
          >
            <li>
              {previous && (
                <Link to={previous.fields.slug} rel="prev">
                  ← Bài sau
                </Link>
              )}
            </li>
            <li>
              {next && (
                <Link to={next.fields.slug} rel="next">
                  Bài trước →
                </Link>
              )}
            </li>
          </ul>
        </nav>
      </div>
      <div className={styles.postComment}>
                123
      </div>
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "DD.MM.YYYY")
        description
        featuredImage        
      }
    }
  }
`
